import { connect } from 'react-redux'
import {
  selectRentalPropertyBudget,
  selectRentalPropertyMinimum
} from 'src/store/selectors/home/equity'
import { defineMessages } from 'react-intl'
import Detail from './Detail'

export default {
  GemContainer: connect(state => {
    const budget = selectRentalPropertyBudget(state)
    const minimum = selectRentalPropertyMinimum(state)
    const enoughEquity = budget > minimum

    return {
      qaTag: 'rentalPropertyGem',
      amount: enoughEquity ? budget : 0,
      qualified: enoughEquity
    }
  }),
  Detail,
  ...defineMessages({
    question: {
      id: 'Homeowner.purchasePower.rentalPropertyQuestion',
      defaultMessage: 'How can I finance a rental?'
    },
    topic: {
      id: 'Homeowner.purchasePower.rentalPropertyTopic',
      defaultMessage: 'buying an investment property'
    }
  })
}
